import { all, takeLatest } from "redux-saga/effects";

import { getUsersSaga } from "./user-list/user-list.saga";
import { AdminActions } from "./admin.actions";
import { updateAuthorizations } from "./user-details/authorization/authorization.sagas";
import {
  createApiKey,
  deleteApiKey,
  updateApiKey
} from "./user-details/api-kyes/api-kyes.sagas";
import {
  approveDevice,
  removeDevice
} from "./user-details/device/device.sagas";

export default function* adminSagas() {
  yield all([
    takeLatest(AdminActions.GET_USERS, getUsersSaga),
    takeLatest(AdminActions.UPDATE_USER_AUTHORIZATIONS, updateAuthorizations),
    takeLatest(AdminActions.CREATE_USER_API_KEY, createApiKey),
    takeLatest(AdminActions.DELETE_USER_API_KEY, deleteApiKey),
    takeLatest(AdminActions.UPDATE_USER_API_KEY, updateApiKey),
    takeLatest(AdminActions.APPROVE_USER_DEVICE, approveDevice),
    takeLatest(AdminActions.REMOVE_USER_DEVICE, removeDevice)
  ]);
}
